module.exports = __webpack_public_path__ + "img/ac1.7d4849b6.png";